import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { LoyaltyEducation } from 'models/common/loyalty-education';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';

import { LoyaltyEducationDialogContent } from './loyalty-education-dialog-content';

export interface LoyaltyEducationDialogProps {
  loyaltyEducation?: LoyaltyEducation;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
}

@inject('routeStore', 'analytics')
export class LoyaltyEducationDialog extends React.Component<LoyaltyEducationDialogProps> {
  private handleDismiss = () => {
    this.props.routeStore.goBack();
  };

  public render(): JSX.Element {
    const toolbarAnalytics = this.props.analytics.setupTracker('RewardsEducationDialog.Close', 'Rewards Education Dialog');
    const { loyaltyEducation } = this.props;

    return (
      <Layer id="join-rewards" onDismiss={this.handleDismiss}>
        <UitkFullscreenDialog dialogShow={true}>
          <UitkToolbar type={ToolbarType.CLOSE} action={this.handleDismiss} analytics={toolbarAnalytics} />
          <UitkDialogContent>
            <LoyaltyEducationDialogContent loyaltyEducation={loyaltyEducation} />
          </UitkDialogContent>
        </UitkFullscreenDialog>
      </Layer>
    );
  }
}
